import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { useAuth } from "../../contexts/AuthContext";
import { clientApiService } from "../../services/client-api.service";

const TITLES: Record<string, string> = {
  "/dashboard": "Inicio",
  "/dashboard/projects": "Mis Proyectos",
  "/dashboard/advances": "Avances",
  "/dashboard/payments": "Estado de Cuenta",
  "/dashboard/documents": "Documentos",
  "/dashboard/messages": "Mensajes",
  "/dashboard/tokens": "Monedero de Tokens",
  "/dashboard/changes": "Órdenes de Cambio",
  "/dashboard/settings": "Configuración",
  "/dashboard/models": "Modelos 3D",
};

export function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [unreadMessages, setUnreadMessages] = useState(0);
  const [pendingChangeOrders, setPendingChangeOrders] = useState(0);
  const location = useLocation();
  const { client } = useAuth();

  const title = TITLES[location.pathname] || "Dashboard";

  useEffect(() => {
    let mounted = true;
    const loadCounters = async () => {
      try {
        const data = await clientApiService.getDashboard();
        if (!mounted) return;
        setUnreadMessages(data.unreadMessages ?? 0);
        setPendingChangeOrders(data.pendingChangeOrders ?? 0);
      } catch {
        /* silent */
      }
    };
    loadCounters();
    const interval = setInterval(loadCounters, 60000);
    return () => {
      mounted = false;
      clearInterval(interval);
    };
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-slate-50 flex">
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        unreadMessages={unreadMessages}
        pendingChangeOrders={pendingChangeOrders}
      />

      <div className="flex-1 flex flex-col min-w-0">
        <Header
          onToggleSidebar={() => setSidebarOpen(true)}
          title={title}
        />
        <main className="flex-1 p-4 lg:p-6 overflow-x-hidden">
          <Outlet context={{ client }} />
        </main>
      </div>
    </div>
  );
}